import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const BadgeBannerStyles = {
  banner: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    border-radius: ${theme.borderRadius.medium};
    background-color: var(--badge-banner-bg);
    border: 1px solid var(--badge-banner-border);
    width: fit-content;
  `,
};
